import register from 'ShopUiBundle/modules/app/registry';

import './style.scss';

// tslint:disable-next-line
register('main-navigation-category-bikes-level-3', () => import(/* webpackMode: "lazy" */'./main-navigation-category-bikes-level-3'));
